import React from 'react';
import {CSSTransition} from 'react-transition-group';
import AgeSelect from './AgeSelect';
import './AgeSelectGroup.less';
import {isEmptyArray, setAgeOptions} from '../../utils/setAgeOptions';

/* eslint-disable complexity */
const AgeSelectGroup = ({
    ageData,
    ageOptions,
    childrenCount,
    onAgeChange,
    ageSelectTitle,
    ageSelectSubtitle,
}) => {
    if (!ageData || isEmptyArray(ageData)) {
        return null;
    }
    const ageSelectOptions = setAgeOptions(ageOptions);
    const expanded = childrenCount > 0;
    const classNamespace = 'age-select-group';
    const labelClassName = `${classNamespace}__label`;
    const infoClassName = `${classNamespace}__info`;
    const formGroupClassName = `${classNamespace}__form-group`;

    return (
        <CSSTransition
            in={expanded}
            appear={expanded}
            timeout={1000}
            classNames={classNamespace}
        >
            <div className={classNamespace}>
                <p className={labelClassName}>
                    {ageSelectTitle}
                </p>
                <p className={infoClassName}>
                    {ageSelectSubtitle}
                </p>
                <div className={formGroupClassName}>
                    {ageData.map((item, i) => {
                        return (
                            <AgeSelect
                                floatingLabel={false}
                                index={i}
                                items={ageSelectOptions}
                                key={i}
                                label={item.value}
                                minAge={ageOptions && ageOptions.minAge}
                                value={item.value}
                                onAgeChange={onAgeChange}
                            />
                        );
                    })}
                </div>
            </div>
        </CSSTransition>
    );
};

export default AgeSelectGroup;